import { setUserProperty, trackEvent } from "./analytics"

function generateRandomNumber(n: number) {
    return Math.floor(Math.random() * n)
}

/** @deprecated See doABTestWithDistribution */
export function doABTest<T extends string>(name: string, choices: T[]): T {
  return doABTestWithDistribution<T>(name, choices.map(x => ({ choice: x, weight: 1})));
}

interface WeightedChoice<T> {
  choice: T;
  weight: number;
  mobileOnly?: boolean;
}

/** You probably want to use 'getABTestGroup' instead of calling this!!!
 * 
 * Gets a choice for an AB test group, or uses a weighted choice, if the choice is not in local storage. This DOES NOT
 * check the query string 
 */
export function doABTestWithDistribution<T extends string>(
  name: string,
  choices: WeightedChoice<T>[]
) {

  const nameChoices = getAbTestNameChoices(name, choices);

  let choice = getABTestChoiceFromStorage(nameChoices) as T;

  if (!choice) {
    choice = weightedChoice(choices);
    if (choice) {
      storeABTestChoice(nameChoices, choice);
      trackABTest(nameChoices, choice);
    }
  }
  return choice;
}

type ABTestChoiceString = string & { __type: 'ABTestChoiceString' };

/** Combines the test name and choices into a single string for tracking and storage purposes */
export function getAbTestNameChoices<T extends string>(
  name: string,
  choices: { choice: T }[]
) {
  return `ABTest_${name}_${choices.map((i) => i.choice).join('')}` as ABTestChoiceString;
}

/** Tracks the AB test choice and sets the user property */
export function trackABTest(nameChoices: ABTestChoiceString, choice: string) {
  console.log(nameChoices, choice);
  trackEvent(nameChoices, { choice: choice });
  setUserProperty(nameChoices, choice);
}

export function weightedChoice<T>(choices: WeightedChoice<T>[]): T {
  const isMobile = typeof window !== 'undefined' ? window.innerWidth < 768 : true;
  const filteredChoices = choices.filter(x => {
    if (x.mobileOnly == undefined) {
      return true;
    }
    if (x.mobileOnly) {
      return isMobile;
    }
    return false;
  });
  const totalWeight = filteredChoices.reduce((acc, { weight }) => acc + weight, 0);
  let rand = Math.random() * totalWeight;

  for (const { choice, weight } of filteredChoices) {
    if (rand < weight) {
      return choice;
    }
    rand -= weight;
  }

  return choices[0].choice; // should never get here but need it as a fallback
}



function getABTestChoiceFromStorage(key: ABTestChoiceString) {
    let choice;
    if (typeof window !== 'undefined') {
      try {
        choice = localStorage.getItem(key)
      }
      catch (e) {
        console.warn('Failed to read localStorage ' + key, e);
      }
    }

    return choice
}


function storeABTestChoice(key: ABTestChoiceString, value: string) {
    if (typeof window !== 'undefined') {
        localStorage.setItem(key, value);
    }
}